import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, REFRESH_TIMESTAMP_KEY } from '../constants';
import qs from 'qs';
import { axiosRequest, axiosRequestEvents, axiosRequestV2, parseErrors, updateTokens } from './utils';
import { getErrorDetails } from './utils/parseErrors';

export const getUserApi = async (dataCb, errCb) => {
  await axiosRequest
    .get('users/me', {
      _auth: true,
    })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const logInApi = async (user, dataCb, errCb) => {
  await axiosRequest
    .post('auth/sign-in', user)
    .then((res) => {
      dataCb(res);
      updateTokens(res.data?.access_token, res.data?.refresh_token);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const logout = async () => {
  await axiosRequest
    .post('auth/logout')
    .then(() => {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TIMESTAMP_KEY);
    })
    .catch((err) => {
      const msg = err?.response?.data;
      if (msg) {
        console.log(JSON.stringify(msg));
      } else {
        console.log('server missing or no internet');
      }
    });
};

export const signUpApi = async (user, dataCb, errCb) => {
  await axiosRequest
    .post('auth/signup', user)
    .then((res) => {
      dataCb(res);
      updateTokens(res.data?.access_token, res.data?.refresh_token);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const verify = async (ticket, setRes, setProgress) => {
  const ticketJson = { ticket: ticket };
  await axiosRequest
    .post('auth/signup/verify', ticketJson)
    .then((res) => {
      setProgress(false);
      setRes(res.data);
    })
    .catch((err) => {
      setProgress(false);
      const msg = err?.response?.data;
      if (msg) {
        setRes(msg);
      } else {
        setRes({ error: err?.name + ' ' + err?.message, type: 'ServerError' });
      }
    });
};

export const verifyResetPassApi = async (ticket, dataCb, errCb) => {
  var query = {};
  query.params = {
    ticket,
  };
  await axiosRequest
    .post('auth/password/reset/verify', null, query)
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const resetPassApi = async (ticket, pass, dataCb, errCb) => {
  var passJson = { password: pass };
  var query = {};
  query.params = {
    ticket,
  };
  await axiosRequest
    .post('auth/password/reset', passJson, query)
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const resendLinkVerification = async (body, dataCb, errCb) => {
  try {
    await axiosRequest.post('auth/resend-verification', body, {
      _auth: true,
    });
    dataCb?.();
  } catch (err) {
    parseErrors(err, errCb);
  }
};

//=====OBJECTS API==============================================

export const getObjectsApi = async (dataCb, errCb) => {
  await axiosRequest
    .get('objects', { _auth: true })
    .then((res) => {
      dataCb(res.data.items);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const addObjectApi = async (object, dataCb, errCb) => {
  await axiosRequest
    .post('objects', object, { _auth: true })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const editObjectApi = async (object, dataCb, errCb) => {
  try {
    const res = await axiosRequest.patch('objects', object, { _auth: true });
    dataCb(res.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const deleteObjectApi = async (id, dataCb, errCb) => {
  var url = 'objects/' + id;
  await axiosRequest
    .delete(url, { _auth: true })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

//=====DEVICES API==============================================

export const getGroupDevices = async (dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('devices/by_objects', { _auth: true });
    dataCb?.(res.data);
    return res.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getDevicesObjApi = async (dataCb, errCb, objectId) => {
  await axiosRequest
    .get('devices', { params: { objectId }, _auth: true })
    .then((res) => {
      dataCb(res.data.items);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const addDeviceApi = async (object, dataCb, errCb) => {
  try {
    const res = await axiosRequestV2.post('devices', object, { _auth: true });
    await dataCb(res.data);
    return res.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const editDeviceApi = async (device, dataCb, errCb) => {
  await axiosRequest
    .patch('devices', device, { _auth: true })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const replaceDevice = async ({ body, dataCb, errCb }) => {
  try {
    await axiosRequest.post('devices/replace', body, { _auth: true });
    dataCb?.();
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const recalculateDataDevice = async ({ deviceId, body, dataCb, errCb }) => {
  try {
    const res = await axiosRequest.post(`devices/${deviceId}/recalculate`, body, { _auth: true });
    dataCb?.();
    return res.data;
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

export const allowNextUpdateApi = async ({ deviceId, allowed, dataCb, errCb }) => {
  try {
    const res = await axiosRequest.post(`devices/${deviceId}/allow_next_update`, { allowed }, { _auth: true });
    dataCb?.(res.data);
    return res.data;
  } catch (err) {
    parseErrors?.(err, errCb);
    throw err;
  }
};

export const updateGroupDevices = async (body, dataCb, errCb) => {
  try {
    const res = await axiosRequest.put('devices/description', body, { _auth: true });
    await dataCb?.(res.data);
    return res.data;
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

export const deleteDevApi = async (id, dataCb, errCb) => {
  var url = 'devices/' + id;
  await axiosRequest
    .delete(url, { _auth: true })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const setDevInputsApi = async (id, inputsArray, dataCb, errCb) => {
  var url = 'devices/' + id + '/inputs';
  await axiosRequest
    .post(url, inputsArray, { _auth: true })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const getDevicesEventsApi = async (params, dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('devices/events', {
      params: params,
      _auth: true,
    });
    dataCb?.(res.data);
    return res.data;
  } catch (error) {
    parseErrors(error, errCb);
  }
};

export const getDevicesConsApi = async (params, dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('devices/events/stats', {
      params: params,
      _auth: true,
    });
    dataCb?.(res.data?.stats);
  } catch (error) {
    parseErrors(error, errCb);
  }
};

export const bindObjDevApi = async (bind, dataCb, errCb) => {
  await axiosRequest
    .post('objects/devices', bind, { _auth: true })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

// пролив воды - запрос каждые 5 секунд после создания устройства:
export const getStatusWaterSpill = async (deviceId, dataCb, errCb) => {
  try {
    const params = { controller_id: deviceId };
    const res = await axiosRequest.get(`/devices/water_spill`, { params, _auth: true });
    dataCb?.(res.data);
    return res.data;
  } catch (err) {
    parseErrors?.(err, errCb);
    throw err;
  }
};

//POST /api/v1/integrations/:integrationKey?deviceId=123
export const addIntegrationApi = async (integConf, integrationKey, deviceId, dataCb, errCb) => {
  await axiosRequest
    .post('integrations/' + integrationKey, integConf, {
      params: {
        deviceId,
      },
      _auth: true,
    })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      getErrorDetails(err, errCb);
    });
};

export const subscribeIntegrationApi = async (integConf, integrationKey, deviceId) => {
  try {
    const res = await axiosRequest.post(`integrations/${integrationKey}/subscribe`, integConf, {
      params: { deviceId },
      _auth: true,
    });
    return res.data;
  } catch (err) {
    parseErrors(err);
    throw err;
  }
};

export const getIntegrationsApi = async (dataCb, errCb, deviceId) => {
  await axiosRequest
    .get('integrations', {
      params: {
        deviceId,
      },
      _auth: true,
    })
    .then((res) => {
      let r = res.data?.values;
      if (r === null) r = [];
      dataCb(r);
    })
    .catch((err) => {
      const msg = err?.response?.data;
      if (msg) {
        errCb(msg);
      } else {
        errCb({ error: err?.name + ' ' + err?.message, type: 'ServerError' });
      }
    });
};

// "reporter.mail":
export const editIntegration = async ({ config, integrationKey, integrationId, deviceId }) => {
  try {
    const res = await axiosRequest.put(`integrations/${integrationKey}/${integrationId}`, config, { params: { deviceId }, _auth: true });
    return res.data;
  } catch (err) {
    parseErrors(err);
    throw err;
  }
};

export const getAllIntegrations = async (dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('integrations/full-info', {
      _auth: true,
    });
    dataCb?.(res.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getTypeIntegrations = async (dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('integrations/active', {
      _auth: true,
    });
    dataCb?.(res.data);
    return res.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getTemplateIntegrations = async (dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('integrations/email-templates', {
      _auth: true,
    });
    dataCb?.(res.data);
    return res.data;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const delIntegrationApi = async (id, integrationKey, deviceId, dataCb, errCb) => {
  await axiosRequest
    .delete('integrations/' + integrationKey + '/' + id, {
      params: {
        deviceId,
      },
      _auth: true,
    })
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

export const resetPassRqApi = async (data, dataCb, errCb) => {
  await axiosRequest
    .post('auth/password/reset/link', data)
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      parseErrors(err, errCb);
    });
};

//events:
export const getUserEventsApi = async (page, limit, searchParams, dataCb, errCb) => {
  const offset = (page - 1) * limit;

  const { deviceId, levels, categories, from, to, message, objectId } = searchParams ?? {};
  const params = {
    ...(categories?.length ? { categories } : {}),
    ...(deviceId ? { deviceId: +deviceId } : {}),
    ...(objectId ? { objectId: +objectId } : {}),
    ...(message ? { message } : {}),
    ...(levels?.length ? { levels } : {}),
    ...(from ? { from: from } : {}),
    ...(to ? { to: to } : {}),
    offset,
    limit,
  };

  try {
    const res = await axiosRequestEvents.get(`/events/user`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      _auth: true,
    });
    dataCb(res.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getDevicesByQuery = async (params, dataCb, errCb) => {
  try {
    const response = await axiosRequest.get(`/devices/dict`, {
      params,
      _auth: true,
    });
    dataCb?.(response);
    return response;
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getEventAggregate = async (params, dataCb, errCb) => {
  try {
    const response = await axiosRequest.get('/devices/events/aggregated', {
      params,
      _auth: true,
    });
    dataCb?.(response.data);
    return response.data?.reverse() ?? [];
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const getEventTypes = async (dataCb, errCb) => {
  try {
    const response = await axiosRequestEvents.get('/event_types');
    dataCb?.(response.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const deleteAccount = async (dataCb, errCb) => {
  try {
    const res = await axiosRequest.delete('/auth', { _auth: true });
    dataCb(res.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const updateUser = async (body, dataCb, errCb) => {
  try {
    await axiosRequest.put('users/profile', body, { _auth: true });
    dataCb?.();
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const updateUserEmail = async (body, dataCb, errCb) => {
  try {
    await axiosRequest.post('users/change-email', body, { _auth: true });
    dataCb?.();
  } catch (err) {
    parseErrors(err, errCb);
  }
};

// расход воды
export const updateWaterThreshold = async (body, errCb) => {
  try {
    await axiosRequest.post('/water-thresholds', body, { _auth: true });
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

export const toggleWaterThreshold = async (body, errCb) => {
  try {
    await axiosRequest.put('/water-thresholds/enable', body, { _auth: true });
  } catch (err) {
    parseErrors?.(err, errCb);
    throw err;
  }
};

export const getWaterThresholds = async (deviceId, dataCb, errCb) => {
  try {
    const res = await axiosRequest.get(`/water-thresholds/${deviceId}`, { _auth: true });
    dataCb?.(res.data);
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

export const sendEmailIntegration = async (device_integration_id, dataCb, errCb) => {
  try {
    const res = await axiosRequest.post('/emails/send-readings', null, {
      params: { device_integration_id },
      _auth: true,
    });
    dataCb?.(res.data);
  } catch (err) {
    parseErrors(err, errCb);
  }
};

export const sendMosruIndication = async (deviceId, dataCb, errCb) => {
  try {
    await axiosRequest.post('integrations/mosru/send_indications', null, { params: { deviceId }, _auth: true });
    dataCb?.();
  } catch (err) {
    const status = err?.response?.status;
    const data = err?.response?.data;

    let errors = [];
    if (status === 400 && Array.isArray(data?.details)) {
      let message = data?.error ?? 'Произошла ошибка';
      let details = [];

      data.details.forEach((detail) => {
        try {
          const parsed = JSON.parse(detail);
          if (Array.isArray(parsed.errors)) {
            parsed.errors.forEach((e) => {
              details.push(e.message);
            });
          }
        } catch {
          details.push(detail);
        }
      });

      if (details.length > 0) {
        message += `\nПодробности:\n${details.join('\n')}`;
      }
      errors.push({ error: message });
      errCb?.(errors);
    } else if (status === 404) {
      errors.push({ error: 'Активные интеграции с mos.ru отсутствуют' });
      errCb?.(errors);
    } else {
      errors.push({ error: `Произошла ошибка при отправке: ${data?.error ?? 'Неизвестная ошибка'}` });
      errCb?.(errors);
    }
  }
};

export const getMosruInformation = async (object_id, dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('integrations/mosru/user_info', { params: { object_id }, _auth: true });
    dataCb(res.data);
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

export const updateMosru = async (id, body, dataCb, errCb) => {
  try {
    await axiosRequest.put(`integrations/mosru/${id}`, body, { _auth: true });
    dataCb?.();
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

// тарифы:
export const updateWaterTariff = async (body, errCb) => {
  try {
    await axiosRequest.post('/water-tariffs', body, { _auth: true });
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

export const getWaterTariff = async (params, dataCb, errCb) => {
  try {
    const res = await axiosRequest.get('/water-tariffs', { params, _auth: true });
    return res.data?.result;
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

export const getCities = async (params) => {
  try {
    const res = await axiosRequest.get('/objects/cities', { params, _auth: true });
    return res.data?.items;
  } catch (err) {
    parseErrors?.(err);
  }
};

export const getOrganizations = async (params) => {
  try {
    const res = await axiosRequest.get('/organizations', { params });
    return res.data ?? [];
  } catch (err) {
    parseErrors?.(err);
  }
};

//payments:
export const getPayments = async ({ page = 1, count = 20, searchParams, dataCb, errCb }) => {
  const newPage = page - 1;
  const { status } = searchParams ?? {};

  const params = {
    ...(status?.length ? { status } : {}),
    page: newPage,
    count,
  };

  try {
    const response = await axiosRequest.get('/payments', { params, _auth: true });
    dataCb?.(response?.data);
    return response?.data;
  } catch (err) {
    parseErrors?.(err, errCb);
  }
};

export const createPayment = async (body) => {
  try {
    const res = await axiosRequest.post('/payments', body, { _auth: true });
    return res.data ?? null;
  } catch (err) {
    parseErrors?.(err);
  }
};

// создание платежа 20мин!!!
// посмотреть свои платежи и их статусы

// окошко
export const checkDevicesPayment = async () => {
  try {
    const res = await axiosRequest.get('/devices/pay-nbiot', { _auth: true });
    return res?.data;
  } catch (err) {
    parseErrors?.(err);
    throw err;
  }
};
